import { KingBed } from '@material-ui/icons';
import AssignmentIcon from '@material-ui/icons/Assignment';
import GroupIcon from '@material-ui/icons/Group';
import CartIcon from '@material-ui/icons/ShoppingCart';
import pillIcon from 'assets/icon/medication-pill.svg';
import { EmptyStateWithText } from 'components/EmptyState';
import routePaths from 'constants/route-paths';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AsideListIconComponent, { AsideListIcon } from '../common/AsideIconMenuItem';

const ListsAsideMenu = () => {
  const { t } = useTranslation();

  const asideListIcons: AsideListIcon[] = [
    {
      label: t('lists_medication'),
      routePath: routePaths.LISTS_MEDICATION,
      svgIcon: pillIcon,
    },
    {
      label: t('lists_visitSheetQuestions'),
      routePath: routePaths.LISTS_VISIT_SHEET_QUESTIONS,
      muiIcon: AssignmentIcon,
    },
    {
      label: t('lists_nursingOverview'),
      routePath: routePaths.LISTS_NURSING_OVERVIEW,
      muiIcon: AssignmentIcon,
    },
    // TODO: uncomment when risk groups is needed again
    // {
    //   label: t('lists_riskGroups'),
    //   routePath: routePaths.LISTS_RISK_GROUPS,
    //   muiIcon: GroupIcon,
    // },
    {
      label: t('lists_riskList'),
      routePath: routePaths.LISTS_RISK_LIST,
      muiIcon: GroupIcon,
    },
    {
      label: t('lists_medicationOrder'),
      routePath: routePaths.LISTS_MEDICATION_ORDERS,
      muiIcon: CartIcon,
    },
    {
      label: t('lists_employeeBaseDataGeneral'),
      routePath: routePaths.LISTS_EMPLOYEE_BASE_DATA_GENERAL,
      muiIcon: GroupIcon,
    },
    {
      label: t('lists_baseDataList'),
      routePath: routePaths.LISTS_BASE_DATA_GENERAL,
      muiIcon: GroupIcon,
    },
    {
      label: t('lists_baseDataKvList'),
      routePath: routePaths.LISTS_BASE_DATA_KV,
      muiIcon: GroupIcon,
    },
    {
      label: t('lists_consultingList'),
      routePath: routePaths.LISTS_BASE_DATA_CONSULTING,
      muiIcon: GroupIcon,
    },
    {
      label: t('lists_externalInformationList'),
      routePath: routePaths.LISTS_EXTERNAL_INFORMATION,
      muiIcon: GroupIcon,
    },
    {
      label: t('lists_referenceCareList'),
      routePath: routePaths.LISTS_BASE_DATA_REFERENCE_CARE,
      muiIcon: GroupIcon,
    },
    {
      label: t('lists_freeBeds'),
      routePath: routePaths.LISTS_FREE_BEDS,
      muiIcon: KingBed,
    },
    {
      label: t('lists_occupancy_indicator'),
      routePath: routePaths.LISTS_OCCUPANCY_INDICATOR,
      muiIcon: KingBed,
    },
  ];

  const [chosen, setChosen] = useState<string>();

  return (
    <div className="aside-menu">
      <ul className="menu-nav py-0">
        {asideListIcons.length ? (
          asideListIcons.map((listItem) => (
            <AsideListIconComponent
              key={listItem.label}
              icon={listItem}
              active={listItem.label === chosen}
              onClick={() => setChosen(listItem.label)}
            />
          ))
        ) : (
          <EmptyStateWithText text={t('no_results_for_current_settings')} verticalPositionTop />
        )}
      </ul>
    </div>
  );
};

export default ListsAsideMenu;
